export default "__VITE_ASSET__38d526cc__"